import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {},
  requesting: false,

  errors: {},
  submitting: false,
  uploading: false,
};

const Slice = createSlice({
  name: '@admin/Profile|Profile',
  initialState,
  reducers: {
    
    getProfile: (state) => {
        state.requesting = true;
    },
    getProfileSuccess: (state, action) => {
        state.user = action.payload;
        state.requesting = false;
    },
    getProfileFailed: (state, action) => {
        state.errors = action.errors;
        state.requesting = false;
    },

    saveProfile: (state) => {
        state.errors = {};
        state.submitting = true;
    },
    saveProfileSuccess: (state) => {
        state.submitting = false;
    },
    saveProfileFailed: (state, action) => {
        state.errors = action.errors;
        state.submitting = false;
    },
    
  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminProfileReducers: Slice.reducer,
}
export default Reducers;